module.exports = __webpack_public_path__ + "img/detail00-2026-02.6920b93a.jpg";